import axios from 'axios';
import Head from 'next/head';
import React from 'react';
import FooterComp from '../components/Footer/Footer';
import HeaderComp from '../components/Header/Header';
import UpdateSoftware from '../components/UpdateSoftware/UpdateSoftware';
import config from '../config/config';
import seo from '../config/seo';
import SetHeaders from '../config/SetHeaders';

const UpdatesContainer = ({ Header, Body, Footer, response }: any) => {
	const components = (typeName: any, compData: any, key: any) => {
		switch (typeName) {
			case 'info.info-component':
				return <UpdateSoftware key={key} data={compData} />;
			default:
				return null;
		}
	};
	return (
		<React.Fragment>
			{response && !response.Seo && (
				<Head>
					<title>{seo.training}</title>
				</Head>
			)}
			{response && <SetHeaders HEADERS={response} />}
			{Header && <HeaderComp HeaderValue={Header} />}
			<div className="app-body">
				{Body &&
					Body.map((data: any, i: number) => {
						return components(data.__component, data, i);
					})}
			</div>
			{Footer && <FooterComp data={Footer} />}
		</React.Fragment>
	);
};

export async function getStaticProps() {
	const { data } = await axios.get(config.endpoints.update)
	return {
		props: {
			Header: data.Header,
			Body: data.Body,
			Footer: data.Footer.Footer,
			response: data
		},
		revalidate: 3600
	}
}

export default UpdatesContainer
